import React from 'react';

import Markdown from '@/components/Markdown';
import { GX_REGEX } from '@/features/AIChat/AskGXDrawer/utils/gxCodes';
import type { AIMessage } from '@/features/AIChat/types/chat';
import WidgetMapper from '@/features/AIChat/widgets/WidgetMapper';

const AIContent = ({ msg }: { msg: AIMessage }) => {
  return (
    <>
      {msg.content.map(part => {
        switch (part.kind) {
          case 'text':
            return (
              <Markdown key={part.text}>
                {part.text.replace(GX_REGEX, match => `[${match}](/${match})`)}
              </Markdown>
            );
          case 'tool_result':
            if (part.display === 'table') {
              return (
                <WidgetMapper
                  key={part.tool_call_id}
                  widgetData={part}
                />
              );
            }
            return null;
          default:
            return null;
        }
      })}
    </>
  );
};

export default AIContent;
